import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, Renderer2 } from '@angular/core';
import { IUserData, UserData } from '../../../../../../globals/classes/userData';
import { IVerifyCodeRequest } from '../../../../../classes/http-requests';
import { AppSettings } from '../../../../../app.settings';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { BaseComponent } from '../../../../../../globals/classes/base.component';

export interface ICodeDigit {
	name: string;
	key: string;
	value: string;
}

@Component({
	selector: 'user-code',
	template: require('./user-code.component.html'),
})
export class UserCodeComponent extends BaseComponent implements OnInit, OnDestroy {
	@Input() verfiyCodeRequest: IVerifyCodeRequest;
	@Output() emitResend: EventEmitter<boolean> = new EventEmitter(false);
	@Input() public isLoginBigModalEnabled: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	public userData: IUserData = new UserData();
	public timerActive: boolean = false;
	public timeRemaining: number = 300;
	private timerSubscription: Subscription;

	private readonly _isIOS: boolean;
	private readonly _isAndroid: boolean;

	public config: ICodeDigit[] = [
		{ name: 'vcode-1', key: 'vcode-1', value: '' },
		{ name: 'vcode-2', key: 'vcode-2', value: '' },
		{ name: 'vcode-3', key: 'vcode-3', value: '' },
		{ name: 'vcode-4', key: 'vcode-4', value: '' },
		{ name: 'vcode-5', key: 'vcode-5', value: '' },
		{ name: 'vcode-6', key: 'vcode-6', value: '' },
	];

	constructor(private _renderer2: Renderer2) {
		super();
		this._isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null;
		this._isAndroid = navigator.userAgent.match(/Android/i) !== null;
	}

	ngOnInit() {
		this.setDynatraceEvent('IB_PR_Enter_Email_Code');
		UserData.data$.subscribe((userData) => (this.userData = userData));
		this.startTimer();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}
	}

	startTimer() {
		this.timerActive = true;
		this.timeRemaining = 300;

		this.timerSubscription = interval(1000)
			.pipe(take(301))
			.subscribe(() => {
				if (this.timeRemaining > 0) {
					this.timeRemaining--;
				} else {
					this.timerActive = false;
					if (this.timerSubscription) {
						this.timerSubscription.unsubscribe();
					}
				}
			});
	}

	public onKeyDown(event: KeyboardEvent, prefix: string, index: number) {
		let key = event.charCode || event.keyCode || 0;

		if (this._isAndroid && key === 229) {
			setTimeout(() => {
				const target = <HTMLInputElement>event.target;
				key = target.value.charCodeAt(target.value.length - 1);
				this.handleKey(key, prefix, index);
			}, 0);
		} else if (this._isIOS) {
			setTimeout(() => {
				this.handleKey(key, prefix, index);
			}, 0);
		} else {
			this.handleKey(key, prefix, index);
		}
	}

	private handleKey(key: number, prefix: string, index: number): void {
		let code: string = '';
		if (
			key === 9 ||
			key === 13 ||
			key === 46 ||
			key === 110 ||
			key === 190 ||
			(key >= 35 && key <= 40)
		) {
			return;
		} else if (key === 8) {
			if (index + 1 > 1) {
				if (this.config[index].value !== '') {
					this.config[index].value = '';
					this.config.forEach((item) => (code += item.value));
					this.verfiyCodeRequest.code = code;
				} else if (this.config[index].value === '') {
					this.config[index - 1].value = '';
					this.config.forEach((item) => (code += item.value));
					this.verfiyCodeRequest.code = code;
					setTimeout(() => {
						let prevEl = this._renderer2.selectRootElement('#' + prefix + index.toString());
						prevEl.focus();
					}, 25);
				}
			}
		} else if ((key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
			this.config[index].value = this.setKeyChar(key);
			if (index + 1 < this.config.length) {
				setTimeout(() => {
					let nextEl = this._renderer2.selectRootElement('#' + prefix + (index + 2).toString());
					nextEl.focus();
				}, 25);
			}
			this.config.forEach((item) => (code += item.value));
			this.verfiyCodeRequest.code = code;
		} else return;
	}

	private setKeyChar(key: number): string {
		if (key >= 96 && key <= 105) {
			key -= 48;
		}
		return String.fromCharCode(key);
	}

	resend() {
		this.emitResend.emit(true);
		this.config.forEach((item) => (item.value = ''));
		this.verfiyCodeRequest.code = '';
		this.startTimer();
	}

	maskEmail(email: string): string {
		if (!email) return '';
		const atIndex = email.indexOf('@');
		if (atIndex === -1) return email;
		return '**********' + email.substring(atIndex);
	}

	formatTime(): string {
		const minutes: number = Math.floor(this.timeRemaining / 60);
		const seconds: number = this.timeRemaining % 60;

		return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	}
}
